import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-invoice-02',
  standalone: true,
  templateUrl: '../../assets/invoice-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamInvoice02Icon {}
